/**
 * Sync accessor for the current LogRocket session URL.
 *
 * Kept in a tiny module (no `logger` import) so `services/logger` can read it
 * without a circular dependency through `vendor/log-rocket`.
 *
 * `startLogRocketSession` registers the client after init; until then (or when
 * LogRocket is disabled) this returns undefined.
 */ let logRocketClient = null;
export function setLogRocketClient(client) {
    logRocketClient = client;
}
/** Current LogRocket session URL, if the client has started a session. */ export function getLogRocketSessionURL() {
    const url = logRocketClient === null || logRocketClient === void 0 ? void 0 : logRocketClient.sessionURL;
    return typeof url === 'string' && url.length > 0 ? url : undefined;
}
